import { render, staticRenderFns } from "./suporte-paises.vue?vue&type=template&id=79793c8d&scoped=true"
import script from "./suporte-paises.vue?vue&type=script&lang=ts"
export * from "./suporte-paises.vue?vue&type=script&lang=ts"
import style0 from "./suporte-paises.vue?vue&type=style&index=0&id=79793c8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79793c8d",
  null
  
)

export default component.exports